/* globals $ */
'use strict';

angular.module('mediacloudApp')
    .directive('mediacloudAppPagination', function() {
        return {
            templateUrl: 'scripts/components/form/pagination.html'
        };
    });
